import { useState } from "react"
import { useSelector } from "react-redux"

import moment from "moment"

import { DATE_TIME_FORMAT } from "../constants"

import { getFullName } from "../utils"


const ApprovalHistory = (props) => {
    const { approvalRequests,  } = props

    const [visible, setIsVisible] = useState(false)
    const userDetails = useSelector(state => state.userDetails)
    const statusData = useSelector(state => state.common.status)

    const pmCompanyUsers = userDetails?.PMCompanyDetails?.companyUsers ? userDetails?.PMCompanyDetails?.companyUsers : []

    return (
        <>  
            <div className="flex justify-content-end">
                <a label="View History" style={{cursor : "pointer"}} onClick={() => setIsVisible(!visible)}>View History<i className={visible ? "pi pi-angle-up pl-1" : "pi pi-angle-down pl-1"}></i></a> 
            </div>
            { visible && 
                <div className="approval-history" style={{borderTop:"0.5px solid #e6dddd"}}>
                    <h4 style={{fontSize:"12px", marginBottom: "0px", marginTop: "4px"}}>APPROVAL HISTORY</h4>
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">S.No</th>
                                    <th className="">Request Raised On</th>
                                    <th className="">Request Remarks</th>
                                    <th className="">Status</th>
                                    <th className="">Processed By</th>
                                    <th className="">Processed Remarks</th>
                                    <th className="">Processed At</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                {
                                    approvalRequests.map((eachApprovalRequest, index) => {
                                        const requestStatus = statusData.find(eachStatus => eachStatus.statusId === eachApprovalRequest.statusId)
                                        const processedBy = pmCompanyUsers.find(eachUser => eachUser.userId === eachApprovalRequest.processedBy)
                                        const createdAt = eachApprovalRequest?.createdAt ? moment(eachApprovalRequest?.createdAt).format(DATE_TIME_FORMAT) : ""
                                        const provessedAt = eachApprovalRequest?.processedAt ? moment(eachApprovalRequest?.processedAt).format(DATE_TIME_FORMAT) : ""
                                        return (
                                            <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }} key={`app-inst-history${eachApprovalRequest.approvalInstanceId}`} >
                                                <td className="">{index + 1}</td>
                                                <td className="">{createdAt}</td>
                                                <td className="">{eachApprovalRequest?.remarks}</td>
                                                <td className="">{requestStatus?.status}</td>
                                                <td className="">{getFullName(processedBy?.firstName, processedBy?.lastName)}</td>
                                                <td className="">{eachApprovalRequest?.processedRemarks}</td>
                                                <td className="">{provessedAt}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            }
        </>
    )
}

export default ApprovalHistory